export default "__VITE_ASSET__Bm19so_5__"